export default __webpack_public_path__ + "static/media/Strike_Symbol_RGB_White_Magenta.04bea694.jpg";